import initialState from "./initial"
import {List, fromJS} from "immutable"

const botsReducer = (state = initialState.bots, action) => {
    if (action.type === "BOTS_LOADING") {
        return state.set("loading", true)
    }
    if (action.type === "BOTS_LOADERROR") {
        return state
            .set("data", List([]))
            .set("loaded", false)
            .set("loading", false)
            .set("loaderror", action.msg)
    }
    if (action.type === "BOTS_LOADED") {
        state = state
            .set("data", fromJS(action.data))
            .set("loaded", true)
            .set("loading", false)
            .set("loaderror", "")
        return state
    }
    return state
}

export default botsReducer
